import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { Draft } from "immer";
import { ApiEndpoints, baseQueryWithAuth } from "../../../core";

interface ApiResponse<T = any> {
  success: boolean;
  message: string;
  result?: T;
  results?: T;
}

export const muscleApi = createApi({
  reducerPath: "muscleApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Muscles"],

  endpoints: (builder) => ({
    getMuscles: builder.query<any, { limit: number }>({
      query: ({ limit }) => ({
        url: `${ApiEndpoints.getAllMuscles}?limit=${limit}`,
        method: "GET",
      }),
      providesTags: ["Muscles"],
    }),
  }),
});

export const { useGetMusclesQuery } = muscleApi;
